export default {
  namespaced: true,
  pagination: {
    title: "Paginação",
    page: "Página:",
    cancel: "Cancelar",
    page_not_found:"Pagina não encontrada",
    next_page: "Próximo",
    prev_page: "Anterior",
  },
};
